<!-- Main container -->
<div class="layout-col full">
  @if (constraints$ | async; as constraintsTemplate) {
    <elder-table
      class="flex outlined"
      matSort
      [data]="constraintsTemplate"
      [selectionMultiEnabled]="true"
      [selectionVisible]="true"
      (itemClick)="onClick($event)"
    >
      <elder-data-toolbar
        *elderTableToolbar
        [canMore]="false"
        [canAdd]="true"
        [canRemove]="true"
        (requestNew)="onNew($event)"
        (requestRemove)="onRemove($event)"
      >
      </elder-data-toolbar>

      <!-- icon -->
      <ng-container matColumnDef="icon">
        <th mat-header-cell *matHeaderCellDef style="width: 5%"></th>
        <td mat-cell *matCellDef="let constraintSpec">
          <div class="place-start-center">
            <mat-icon [matTooltip]="'ID: ' + constraintSpec.id">label</mat-icon>
          </div>
        </td>
      </ng-container>

      <!-- description -->
      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef style="width: 30%">
          {{ 'context.description' | translate }}
        </th>
        <td mat-cell *matCellDef="let constraintSpec">
          <div class="layout-col">
            <span>{{ constraintSpec.description }}</span>
          </div>
        </td>
      </ng-container>

      <!-- property Column -->
      <ng-container matColumnDef="code">
        <th mat-header-cell *matHeaderCellDef style="width: 30%">
          {{ 'products.properties.property' | translate }}
        </th>
        <td mat-cell *matCellDef="let constraintSpec">
          <div class="layout-col">
            <span>{{ constraintSpec?.property?.description }}</span>
            <span class="text-body-small">{{ constraintSpec?.property?.id }}</span>
          </div>
        </td>
      </ng-container>

      <!-- operator Column -->
      <ng-container matColumnDef="operator">
        <th mat-header-cell *matHeaderCellDef style="width: 10%">
          {{ 'skillSets.constraints.operator' | translate }}
        </th>
        <td mat-cell *matCellDef="let constraintSpec">
          {{ 'ConstraintOperator.' + constraintSpec.operator | translate }}
        </td>
      </ng-container>

      <!-- input required Column -->
      <ng-container matColumnDef="inputRequired">
        <th mat-header-cell *matHeaderCellDef style="width: 10%">
          {{ 'context.input-required' | translate }}
        </th>
        <td mat-cell *matCellDef="let constraintSpec">
          {{ (constraintSpec.inputRequired ? 'actions.yes' : 'actions.no') | translate }}
        </td>
      </ng-container>

      <!-- optional Column -->
      <ng-container matColumnDef="optional">
        <th mat-header-cell *matHeaderCellDef style="width: 10%">
          {{ 'context.optional' | translate }}
        </th>
        <td mat-cell *matCellDef="let constraintSpec">
          {{ (constraintSpec.matchIfMissingProp ? 'actions.yes' : 'actions.no') | translate }}
        </td>
      </ng-container>

      <!-- single selection Column -->
      <ng-container matColumnDef="singleSelection">
        <th mat-header-cell *matHeaderCellDef style="width: 10%">
          {{ 'context.single-selection' | translate }}
        </th>
        <td mat-cell *matCellDef="let constraintSpec">
          {{
            PropertyUtil.supportsSingleSelectionSetting(constraintSpec?.property?.type)
              ? ((constraintSpec.singleSelection ? 'actions.yes' : 'actions.no') | translate)
              : ''
          }}
        </td>
      </ng-container>
    </elder-table>
  }
</div>
